import { ingestAPIObject } from "../utils/api";
class GVAUserBase {
}
export class GVAUserDTO extends GVAUserBase {
    constructor(jsonData) {
        super();
        ingestAPIObject(this, jsonData);
    }
}
export class GVAUserPrivilegedDTO extends GVAUserBase {
    constructor(jsonData) {
        super();
        this.needsToSignAgreement = false;
        this.admin = false;
        ingestAPIObject(this, jsonData);
        if (this.createdOnUtc) {
            this.createdOnUtc = new Date(this.createdOnUtc);
        }
        if (this.userAgreementDate) {
            this.userAgreementDate = new Date(this.userAgreementDate);
        }
    }
    /**
     * Returns true if this is a managed account (no email).
     * Keep consistent with GVAUser.IsManagedAccount in the backend.
     */
    get isManagedAccount() {
        return !this.email;
    }
    hasPermission(permission) {
        if (!this.permissions)
            return false;
        return this.permissions.includes(permission);
    }
    hasAnyPermission(...permissions) {
        if (!this.permissions)
            return false;
        return permissions.some((permission) => this.permissions.includes(permission));
    }
    hasAllPermissions(...permissions) {
        if (!this.permissions)
            return false;
        return permissions.every((permission) => this.permissions.includes(permission));
    }
    userAgreementString() {
        if (!this.userAgreementMajorVersion ||
            !this.userAgreementMinorVersion) {
            return;
        }
        return `${this.userAgreementMajorVersion}.${this.userAgreementMinorVersion}`;
    }
}
export class CreateGVAUserDTO {
    constructor(jsonData) {
        ingestAPIObject(this, jsonData);
    }
}
